module.exports = __webpack_public_path__ + "img/Download Center.5f76b950.svg";